import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapActionTransitionFromCrud } from '../../services/mapping/mapActionTransitionsFromCrud'
import { IOnboardingState, IRequestActionParams } from '../models'

export const getActionTransitionsPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.actionTransitionsData.meta = meta
  state.actionTransitionsData.status = RequestStatus.PENDING
  state.actionTransitionsData.message = ''
}

export const getActionTransitionsRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.actionTransitionsData.meta = meta
  state.actionTransitionsData.status = RequestStatus.REJECTED
  state.actionTransitionsData.message = action.payload as string
}

export const getActionTransitionsFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestActionParams }>
) => {
  const { meta, payload } = action

  state.actionTransitionsData.meta = meta
  state.actionTransitionsData.status = RequestStatus.FULFILLED
  state.actionTransitionsData.message = ''
  if (payload) {
    state.actionTransitionsData.data = mapActionTransitionFromCrud(payload.requestActionTransitions)
  }
}
